import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { List } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { Alert, Card } from "react-bootstrap";

interface Props extends AbstractStepProps {
	messages?: string[];
}

export class Error extends AbstractStep<{}, Props> {
	protected renderContent(): ReactNode {
		const { messages } = this.props;

		return (
			<>
				<Card.Header className="text-center text-white bg-danger">
					<Card.Title>Sajnos nem találtunk a megadott feltételeknek megfelelő hitelt.</Card.Title>
				</Card.Header>
				<Card.Body>
					<div className="h6">Az alábbi ok(ok) miatt, számodra sajnos nem elérhető a személyi kölcsön:</div>
					<Alert variant="info">
						<List itemStyle="warning-triangle" variant="danger" className="mb-1">
							{messages.map((msg, key) => (
								<List.Item key={key}>{msg}</List.Item>
							))}
						</List>
					</Alert>
				</Card.Body>
			</>
		);
	}

	protected getComponentName(): string {
		return "Error";
	}
}
